import { render, staticRenderFns } from "./CallingDialog.vue?vue&type=template&id=75456884&scoped=true"
import script from "./CallingDialog.vue?vue&type=script&lang=js"
export * from "./CallingDialog.vue?vue&type=script&lang=js"
import style0 from "./CallingDialog.vue?vue&type=style&index=0&id=75456884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75456884",
  null
  
)

export default component.exports